import { DateTime } from "luxon"
import { useEffect, useState } from "react"
import { minutes } from "../utilities/constants"

const useCurrentTime = () => {
    const [currentTime, setCurrentTime] = useState(DateTime.utc().ts)

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentTime(DateTime.utc().ts)
        }, 1 * minutes)
    
        return () => clearInterval(interval)
    }, [])

    return currentTime
}

export default useCurrentTime